import React, {PropTypes} from 'react';
import {
  DropdownButton, 
  MenuItem
} from 'react-bootstrap';
import moment from 'moment';
import classNames from 'classnames';
import CartEntryFormContainer from './CartEntryFormContainer.jsx';
import Panel from 'shared/Panel.jsx';

const CartEntry = ({
  zindexvalue,
  disableState,
  editing,
  eventName,
  id,
  name,
  cartRosterId,
  isCancelled,
  readOnly,
  squadDateTime,
  onViewRosterClick,
  onManageRosterClick,
  onRemoveRosterItemClick,
  rosterComplete,
  showCalculatedDivisionToCaptain,
  divisionName
}) => (
  <div>
    <div className="list-group-item-labeled"
      style={{position: 'relative', zIndex: zindexvalue}}>
      <div className="list-group-item-labeled-child custom-checkbox-container"
        style={{width: 25}} />
      <div className="list-group-item-labeled-child"
        style={{width: 125}}>
        <span>{'Event Name'}</span>
        <span>{eventName}</span>
      </div>
      <div className="list-group-item-labeled-child"
        style={{width: 295}}>
        <span>{'Team Name'}</span>
        <span>{name}</span>
      </div>
      <div className="list-group-item-labeled-child"
        style={{width: 220}}>
        <span>{'Date'}</span>
        <span>
          {moment.parseZone(squadDateTime).format('hh:mm A, MMM Do, YYYY')}
        </span>
      </div>
      <div className="list-group-item-labeled-child"
        style={{width: 110}} />
        {!rosterComplete
          ? <div className={classNames(
            'list-group-item-labeled-child',
            {'bg-info': !rosterComplete}
          )}
          style={{width: 170}}>          
          <button className="btn btn-link bg-info bold-font"
            type="button"
            disabled
            style={{color: '#000'}}>
              {'Roster Incomplete'}
            </button>
          </div>  
          : showCalculatedDivisionToCaptain
          ? <div className="list-group-item-labeled-child"
                  style={{width: 170}}>
              <span>{'Division'}</span>
              <span>{divisionName}</span> 
            </div>
          : <div className="list-group-item-labeled-child"
          style={{width: 170}} />  
        }    
      {isCancelled
        ? <div className="list-group-item-labeled-child"
            style={{width: 90}} />
        : <div className="list-group-item-labeled-child"
            style={{width: 90}}>
            <DropdownButton id={`actions-dropdown-${id}`}
              className="btn btn-link"
              title={"Actions"}>
              <MenuItem className={classNames(
                  'entry-dropdown-link',
                  {'bg-info bold-font': !rosterComplete}
                )}
                onSelect={() => readOnly ? onViewRosterClick(cartRosterId) : onManageRosterClick(cartRosterId)}
                eventKey="manageRoster">
                {readOnly ? 'View Roster' : 'Manage Roster'}
              </MenuItem>
              <MenuItem className="entry-dropdown-link"
                onSelect={() => onRemoveRosterItemClick(cartRosterId)}
                eventKey="removeRosteritem">
                {'Remove Entry'}
              </MenuItem>
            </DropdownButton>
          </div>
      }
    </div>
    {editing
      ?
        <Panel className="panel-primary animated fadeIn"
          style={{position: 'relative', zIndex: 0}}
          title={
            <span className="flex space-between">
              <h3 className="panel-title">{'Entry and Roster Information'}</h3>
              <div className="flex right wrap">
                <a
                  className="btn btn-link"
                  href="http://webapps.bowl.com/USBCFindA"
                  target="_blank">{'Find a member'}</a>
              </div>
            </span>
          }>
          <CartEntryFormContainer disableState={disableState} />
        </Panel>
      : null
    }
  </div>
);

CartEntry.propTypes = {
  zindexvalue: PropTypes.number,
  disableState: PropTypes.bool,
  editing: PropTypes.bool,
  eventName: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  cartRosterId: PropTypes.string,
  readOnly: PropTypes.bool,
  squadDateTime: PropTypes.string,
  isCancelled: PropTypes.bool,
  onViewRosterClick: PropTypes.func,
  onManageRosterClick: PropTypes.func,
  onRemoveRosterItemClick: PropTypes.func,
  rosterComplete: PropTypes.bool,
  showCalculatedDivisionToCaptain: PropTypes.bool,
  divisionName: PropTypes.string
};

export default CartEntry;



// WEBPACK FOOTER //
// ./src/features/registration/rostercheckout/CartEntry.jsx